/* eslint-disable camelcase */
export var Lang;
(function (Lang) {
    Lang["af"] = "af";
    Lang["ar_AE"] = "ar_AE";
    Lang["ar_BH"] = "ar_BH";
    Lang["ar_DZ"] = "ar_DZ";
    Lang["ar_EG"] = "ar_EG";
    Lang["ar_IQ"] = "ar_IQ";
    Lang["ar_JO"] = "ar_JO";
    Lang["ar_KW"] = "ar_KW";
    Lang["ar_LB"] = "ar_LB";
    Lang["ar_LY"] = "ar_LY";
    Lang["ar_MA"] = "ar_MA";
    Lang["ar_OM"] = "ar_OM";
    Lang["ar_QA"] = "ar_QA";
    Lang["ar_SA"] = "ar_SA";
    Lang["ar_SY"] = "ar_SY";
    Lang["ar_TN"] = "ar_TN";
    Lang["ar_YE"] = "ar_YE";
    Lang["az"] = "az";
    Lang["be"] = "be";
    Lang["bg"] = "bg";
    Lang["bs"] = "bs";
    Lang["ca"] = "ca";
    Lang["cs"] = "cs";
    Lang["cy"] = "cy";
    Lang["da"] = "da";
    Lang["de"] = "de";
    Lang["de_AT"] = "de_AT";
    Lang["de_CH"] = "de_CH";
    Lang["de_LI"] = "de_LI";
    Lang["de_LU"] = "de_LU";
    Lang["dv"] = "dv";
    Lang["el"] = "el";
    Lang["en_AU"] = "en_AU";
    Lang["en_BZ"] = "en_BZ";
    Lang["en_CA"] = "en_CA";
    Lang["en_CB"] = "en_CB";
    Lang["en_GB"] = "en_GB";
    Lang["en_IE"] = "en_IE";
    Lang["en_JM"] = "en_JM";
    Lang["en_NZ"] = "en_NZ";
    Lang["en_PH"] = "en_PH";
    Lang["en_TT"] = "en_TT";
    Lang["en_US"] = "en_US";
    Lang["en_ZA"] = "en_ZA";
    Lang["en_ZW"] = "en_ZW";
    Lang["eo"] = "eo";
    Lang["es_AR"] = "es_AR";
    Lang["es_BO"] = "es_BO";
    Lang["es_CL"] = "es_CL";
    Lang["es_CO"] = "es_CO";
    Lang["es_CR"] = "es_CR";
    Lang["es_DO"] = "es_DO";
    Lang["es_EC"] = "es_EC";
    Lang["es_GT"] = "es_GT";
    Lang["es_HN"] = "es_HN";
    Lang["es_MX"] = "es_MX";
    Lang["es_NI"] = "es_NI";
    Lang["es_PA"] = "es_PA";
    Lang["es_PE"] = "es_PE";
    Lang["es_PR"] = "es_PR";
    Lang["es_PY"] = "es_PY";
    Lang["es_SV"] = "es_SV";
    Lang["es_UY"] = "es_UY";
    Lang["es_VE"] = "es_VE";
    Lang["et"] = "et";
    Lang["eu"] = "eu";
    Lang["fa"] = "fa";
    Lang["fi"] = "fi";
    Lang["fo"] = "fo";
    Lang["fr_BE"] = "fr_BE";
    Lang["fr_CA"] = "fr_CA";
    Lang["fr_CH"] = "fr_CH";
    Lang["fr_FR"] = "fr_FR";
    Lang["fr_LU"] = "fr_LU";
    Lang["fr_MC"] = "fr_MC";
    Lang["gl"] = "gl";
    Lang["gu"] = "gu";
    Lang["he"] = "he";
    Lang["hi"] = "hi";
    Lang["hr"] = "hr";
    Lang["hu"] = "hu";
    Lang["hy_AM"] = "hy_AM";
    Lang["id"] = "id";
    Lang["is"] = "is";
    Lang["it_CH"] = "it_CH";
    Lang["it_IT"] = "it_IT";
    Lang["ja_JP"] = "ja_JP";
    Lang["ka"] = "ka";
    Lang["kk"] = "kk";
    Lang["kn"] = "kn";
    Lang["ko"] = "ko";
    Lang["ky"] = "ky";
    Lang["lt"] = "lt";
    Lang["lv"] = "lv";
    Lang["mi"] = "mi";
    Lang["mk"] = "mk";
    Lang["mn"] = "mn";
    Lang["mr"] = "mr";
    Lang["ms_BN"] = "ms_BN";
    Lang["ms_MY"] = "ms_MY";
    Lang["mt"] = "mt";
    Lang["nb"] = "nb";
    Lang["nl_NL"] = "nl_NL";
    Lang["nl_BE"] = "nl_BE";
    Lang["nn"] = "nn";
    Lang["ns"] = "ns";
    Lang["pa_IN"] = "pa_IN";
    Lang["pl"] = "pl";
    Lang["pt_BR"] = "pt_BR";
    Lang["pt_PT"] = "pt_PT";
    Lang["qu_BO"] = "qu_BO";
    Lang["qu_EC"] = "qu_EC";
    Lang["qu_PE"] = "qu_PE";
    Lang["ro"] = "ro";
    Lang["ru"] = "ru";
    Lang["sa"] = "sa";
    Lang["se_FI"] = "se_FI";
    Lang["se_NO"] = "se_NO";
    Lang["se_SE"] = "se_SE";
    Lang["sk"] = "sk";
    Lang["sl"] = "sl";
    Lang["sq"] = "sq";
    Lang["sr_BA"] = "sr_BA";
    Lang["sr_SP"] = "sr_SP";
    Lang["sv_FI"] = "sv_FI";
    Lang["sv_SV"] = "sv_SV";
    Lang["sw"] = "sw";
    Lang["syr"] = "syr";
    Lang["ta"] = "ta";
    Lang["te"] = "te";
    Lang["th"] = "th";
    Lang["tl_PH"] = "tl_PH";
    Lang["tn"] = "tn";
    Lang["tr"] = "tr";
    Lang["ts"] = "ts";
    Lang["tt"] = "tt";
    Lang["uk"] = "uk";
    Lang["ur"] = "ur";
    Lang["uz"] = "uz";
    Lang["vi"] = "vi";
    Lang["xh"] = "xh";
    Lang["zh_CN"] = "zh_CN";
    Lang["zh_HK"] = "zh_HK";
    Lang["zh_MO"] = "zh_MO";
    Lang["zh_SG"] = "zh_SG";
    Lang["zh_TW"] = "zh_TW";
    Lang["zu"] = "zu";
})(Lang || (Lang = {}));
